export function generateSlug(title: string): string {
  const timestamp = Date.now();
  const sanitized = title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  return `${sanitized}-${timestamp}`;
}

export function generateMasterFileName(extension: string): string {
  return `master.${extension}`;
}

export function generateRatioFileName(title: string, ratio: string): string {
  return `${title}_${ratio}.jpg`;
}

export function generatePdfPath(slug: string, timestamp: number): string {
  return `pdfs/${slug}-${timestamp}.pdf`;
}

export const PDF_LINK_TEXT = 'Click here to download your files';
